module.exports = __webpack_public_path__ + "img/correctbtn_on.1afcbd05.png";